import { Stop } from '@stadtlandnetz/core'
import { request } from './api-resource.base'
import { getHttpOptions } from '../stores/api.stores'

export class StopsResource {
    async getAll(): Promise<Stop[]> {
        return request(`/transport/stops`, getHttpOptions('GET'))
    }
}